export default __webpack_public_path__ + "static/media/icon-2.9f8f002c.svg";